import { render, staticRenderFns } from "./SysInit.vue?vue&type=template&id=8bb75be0&scoped=true&"
import script from "./SysInit.vue?vue&type=script&lang=js&"
export * from "./SysInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb75be0",
  null
  
)

export default component.exports